import { PiPlusBold } from 'react-icons/pi';
import { Link, useLocation } from 'react-router-dom';
import './new-recipe.scss';

export const NewRecipe = () => {
    const location = useLocation();

    function conditionalRender() {
        return location.pathname === '/' &&
        (
        <Link className="btn-new-recipe" to="/receta/nueva">
            <PiPlusBold />
            <span>Agregar Receta</span>
        </Link>
        );
    }

    return (
        <>
        {conditionalRender()}
        </>
    );
};
